
import Localizer from '../format/localizer';

var LicenseType = require('./licenseType');
var HeaderType = require('./headerType');
var Pricing = require('./pricing');

export default {
    
        isFullStakes: function(lic) {
            return lic.fullLicense;
        },
        isSmallStakes: function(lic) {
            return !lic.fullLicense;
        },

        isExpired: function(lic) {
            return lic.expires < Date.now();
        },

        isExpiring: function(lic) {
            if ( lic.cancelled)
                // a license is cancelled when still active but user cancelled it
                // when it expires, the license will become "expired"
                return true;

            return lic.expires > Date.now() && lic.expires < 30 * 24 * 60 * 60 * 1000 + Date.now();
        },

        // mla-279 - i want to know if the user has ever paid for this product before (even if it's expired now)
        hasHadMaintenanceContract: function(lic) {
            if ( lic.state == LicenseType.NoLicense)
                return false;
            
            if ( lic.state == LicenseType.Trial)
                if ( lic.expires != lic.trialExpires)
                    return true;

            if ( lic.state == LicenseType.Freemium)
                if ( lic.expires != null)
                    return true;

            if ( lic.state == LicenseType.Maintenance)
                return true;
            
            return false;
        },



        headerFriendlyName: function(lic) {
            var friendly = "HM";
            switch (lic.headerType) {
                case HeaderType.Hm3: friendly = Localizer.format(Localizer.keys.holdemManager) ; break;
                case HeaderType.Omaha: friendly = Localizer.format(Localizer.keys.omaha); break;
                case HeaderType.HmApps: friendly = Localizer.format(Localizer.keys.hmApps); break;
                default: console.assert(false); break;
            }
            return friendly ;
        },

        friendlyName: function(lic) {
            var friendly = this.headerFriendlyName(lic);
            var suffix = this.isSmallStakes(lic) ? Localizer.format(Localizer.keys.smallStakes) : Localizer.format(Localizer.keys.allStakes);
            return friendly + " " + suffix;
        },

        headerText: function(lic) {
            if ( lic.headerType == HeaderType.HmApps)
                return ""; // HM APPS - where you select the HM app to manage/view

            var expiredDays = parseInt( (Date.now() - lic.trialExpires) / (24 * 60 * 60 * 1000) );
            var expiresDays = -expiredDays;

            switch (lic.state) {
                case LicenseType.Trial: 
                    if ( expiresDays >= 0)
                        return Localizer.format(Localizer.keys.headerTextTrial, [expiresDays]) ;
                    else 
                        return Localizer.format(Localizer.keys.expiredHeaderTextTrial) ;
                        
                case LicenseType.NoLicense: return "";
                case LicenseType.Freemium:  return Localizer.format(Localizer.keys.headerTextFree);
                case LicenseType.Maintenance:
                    return this.isSmallStakes(lic) ? Localizer.format(Localizer.keys.smallStakes) : Localizer.format(Localizer.keys.allStakes) ;
            }
            console.assert(false);
            return "-";
        },



        myProductText: function (lic) {
            switch (lic.headerType) {
                case HeaderType.Hm3: return Localizer.format(Localizer.keys.holdemManagerCaps);
                case HeaderType.Omaha: return Localizer.format(Localizer.keys.omahaCaps) ;
                case HeaderType.HmApps: return Localizer.format(Localizer.keys.hmApps) ;
                default: console.assert(false); break;
            }
            return Localizer.format(Localizer.keys.holdemManagerCaps);
        },




        buyTextHeader: function(lic) {
            switch (lic.headerType) {
                case HeaderType.Hm3: return Localizer.format(Localizer.keys.hm3);
                case HeaderType.Omaha: return Localizer.format(Localizer.keys.om3);
                case HeaderType.HmApps: return Localizer.format(Localizer.keys.hmApps) ;
                default: console.assert(false); break;
            }
        },
        buyBothTextHeader: function(lic) {
            switch (lic.headerType) {
                case HeaderType.Hm3: return Localizer.format(Localizer.keys.hm3andOm3) ;
                case HeaderType.Omaha: return Localizer.format(Localizer.keys.hm3andOm3);
                case HeaderType.HmApps: return Localizer.format(Localizer.keys.hmApps) ;
                default: console.assert(false); break;
            }
        },


        buySmallStakesText: function(lic) {
            switch (lic.headerType) {
                case HeaderType.Hm3: return Localizer.format(Localizer.keys.buyHoldemSmallStakes) ;
                case HeaderType.Omaha: return Localizer.format(Localizer.keys.buyOmahaSmallStakes) ;
                case HeaderType.HmApps: return Localizer.format(Localizer.keys.hmApps) ;
                default: console.assert(false); break;
            }
        },
        buyAllStakesText: function(lic) {
            switch (lic.headerType) {
                case HeaderType.Hm3: return Localizer.format(Localizer.keys.buyHoldemAllStakes) ;
                case HeaderType.Omaha: return Localizer.format(Localizer.keys.buyOmahaAllStakes) ;
                case HeaderType.HmApps: return Localizer.format(Localizer.keys.hmApps);
                default: console.assert(false); break;
            }
        },
        buyBothAllStakesText: function(lic) {
            switch (lic.headerType) {
                case HeaderType.Hm3: return Localizer.format(Localizer.keys.buyHoldemOmahaAllStakes) ;
                case HeaderType.Omaha: return Localizer.format(Localizer.keys.buyHoldemOmahaAllStakes);
                case HeaderType.HmApps: return Localizer.format(Localizer.keys.hmApps) ;
                default: console.assert(false); break;
            }
        },


}




// WEBPACK FOOTER //
// ./src/state/licenseInfoOps.js